import React from 'react';
import { Customer } from '../../model/customer';
import { entityManagerProvider } from '../../model/entity-manager-provider';
import { EntityManager, EntityQuery } from 'breeze-client';
import moment from 'moment';
import { Card, Table } from 'react-bootstrap';
import { Loader } from '@progress/kendo-react-indicators';
import { Country } from '../../model/country';

interface CustomerList {
  customer: Customer[];
  countries: Country[];
  selected: Customer;
  ids: number;
  loading: boolean;
}

class Customers extends React.Component<any, CustomerList> {
  manager: EntityManager;
  constructor(props) {
    super(props);
    this.state = {
      customer: [] as Customer[],
      countries: [] as Country[],
      selected: null as Customer,
      ids: 0 as number,
      loading: true,
    };
    this.manager = entityManagerProvider.newManager();

    this.saveChanges = this.saveChanges.bind(this);
    this.rejectChanges = this.rejectChanges.bind(this);
    this.addCustomer = this.addCustomer.bind(this);
    this.remove = this.remove.bind(this);
    this.cancleSelection = this.cancleSelection.bind(this);
  }

  cancleSelection() {
    this.rejectChanges();
  }
  componentDidMount() {
    entityManagerProvider.subscribeComponent(this.manager, this);

    const query = new EntityQuery('Customers').expand('country');
    const countriesQuery = new EntityQuery('Countries');
    this.manager.executeQuery(query).then((qr) => {
      this.setState({
        selected: null,
        customer: qr.results,
        loading: false,
      });
      this.manager.executeQuery(countriesQuery).then((countriesQr) => {
        this.setState({
          countries: countriesQr.results,
        });
      });
    });
  }
  componentWillUnmount() {
    entityManagerProvider.unsubscribeComponent(this.manager, this);
  }
  addCustomer() {
    this.setState({
      ids: this.state.ids - 1,
    });
    let customer = this.manager.createEntity(Customer.prototype.entityType, {
      applicationUserId: this.props.authorizedUser.Id,
      createdOn: new Date(),
      modifiedOn: new Date(),
      customerId: this.state.ids,
    }) as Customer;

    // select the new customer, and add it to the list of customers
    this.setState({
      selected: customer,
      customer: this.state.customer.concat([customer]),
    });
  }

  remove(ent: Customer) {
    ent.entityAspect.setDeleted();
    this.saveChanges();
  }
  dateFormatter(cell) {
    if (!cell) {
      return '';
    }
    return `${
      moment(cell).format('DD-MM-YYYY')
        ? moment(cell).format('DD-MM-YYYY')
        : moment(cell).format('DD-MM-YYYY')
    }`;
  }

  isPaidString(isPaid) {
    if (isPaid) {
      return 'Paid';
    }
    return 'Not Paid';
  }
  saveChanges() {
    this.setState({
      loading: true,
    });
    this.manager
      .saveChanges()
      .then(() => {
        // refresh customer list to remove deleted customers
        this.setState({
          selected: null,
          customer: this.manager.getEntities('Customer') as Customer[],
          loading: false,
        });
      })
      .catch(function(error) {
        console.log('error catch', error, error.entityErrors);
      })
      .finally(() => {
        const query = new EntityQuery('Customers');
        this.manager.executeQuery(query).then((res) => {
          this.setState({
            selected: null,
            customer: res.results,
            loading: false,
          });
        });
      });
  }

  rejectChanges() {
    this.manager.rejectChanges();
    // refresh customer list to restore original state
    let customers = this.manager.getEntities('Customer') as Customer[];
    customers = customers.sort((a, b) => a.customerId - b.customerId);
    this.setState({
      selected: null,
      customer: customers,
    });
  }

  renderPaymentEdit() {
    let customer = this.state.selected;
    function handleCountryChange(event) {
      customer.countryId = event.target.value;
    }
    if (customer) {
      return (
        <div>
          <Card border="primary" style={{ width: '100%' }}>
            <Card.Header>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={!this.manager.hasChanges()}
                onClick={this.saveChanges}
              >
                <i className="fa fa-save"></i>
                Save Changes
              </button>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={
                  !this.manager.hasChanges() ||
                  this.state.selected?.countryId > 0
                }
                onClick={this.rejectChanges}
              >
                <i className="fa fa-redo"></i>
                Revert Changes
              </button>
              <button
                className="btn btn-danger ml-2"
                type="button"
                onClick={this.remove.bind(this, customer)}
              >
                <i className="fa fa-trash"></i>
                Delete
              </button>
            </Card.Header>
            <Card.Body>
              <Card.Title>Primary Card Title</Card.Title>

              <form>
                <div className="form-group row">
                  <div className="col-lg-6">
                    <label>Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="customerName"
                      value={customer.customerName || ''}
                      onChange={customer.handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label>Mobile</label>
                    <input
                      className="form-control"
                      type="text"
                      name="customerMobile"
                      value={customer.customerMobile || ''}
                      onChange={customer.handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label>Phone</label>
                    <input
                      className="form-control"
                      type="text"
                      name="customerPhone"
                      value={customer.customerPhone || ''}
                      onChange={customer.handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label>Address</label>
                    <input
                      className="form-control"
                      type="text"
                      name="customerLoctaion"
                      value={customer.customerLoctaion || ''}
                      onChange={customer.handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label>Website</label>
                    <input
                      className="form-control"
                      type="text"
                      name="website"
                      value={customer.website || ''}
                      onChange={customer.handleChange}
                    />
                  </div>

                  <div className="col-lg-12">
                    <label>Country</label>
                    <select
                      className="form-control"
                      name="countryId"
                      onChange={handleCountryChange}
                      value={customer.countryId || 0}
                    >
                      <option key={0} value={0}>
                        Select Country
                      </option>
                      {this.state.countries?.map((country) => {
                        return (
                          <option
                            key={country.countryId}
                            value={country.countryId}
                          >
                            {country.countryName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </form>
            </Card.Body>
          </Card>
        </div>
      );
    }
  }
  render() {
    return (
      <div>
        <Card border="primary" style={{ width: '100%' }}>
          <Card.Header>
            <button
              className="btn btn-primary ml-2"
              type="button"
              onClick={this.addCustomer}
            >
              <i className="fa fa-plus"></i>
              Add Customer
            </button>
            <button
              className="btn btn-warning ml-2"
              type="button"
              onClick={this.cancleSelection}
            >
              <i className="fa fa-undo"></i>
              Cancel
            </button>
          </Card.Header>
          <Card.Body>
            <Card.Title>Customer List</Card.Title>
            {this.renderPaymentEdit()}
            <div className="card card-custom card-stretch">
              {this.state.loading ? (
                <div className="row" style={{ minHeight: '200px' }}>
                  <Loader
                    size="large"
                    style={{ position: 'relative', margin: '60px auto' }}
                    type="converging-spinner"
                  />
                </div>
              ) : (
                <Table className="table" responsive="sm" bordered>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Mobile</th>
                      <th>Country</th>
                      <th>Created</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.customer?.map((customer, idx) => {
                      return (
                        <tr
                          key={customer.customerId}
                          style={{
                            backgroundColor:
                              customer === this.state.selected
                                ? 'lightgray'
                                : 'white',
                          }}
                          onClick={() => this.setState({ selected: customer })}
                        >
                          <td>{customer.customerId}</td>
                          <td>{customer.customerName}</td>
                          <td>{customer.customerMobile}</td>
                          <td>{customer.country?.countryName}</td>
                          <td>{this.dateFormatter(customer.createdOn)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              )}
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default Customers;
